<script setup lang="ts">

import PageContentWrapper from '@/application/layouts/ContentWrapper/PageContentWrapper.vue';
import BankAccountCard from '@/contracts/components/BankAccountCard.vue';
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert, ElCard } from 'element-plus';
import Heading from '@/application/components/Heading.vue';
import BankAccountsSkeleton from '@/user/components/BankAccountsSkeleton.vue';
import CreateBankAccountModal from '@/user/components/CreateBankAccountModal.vue';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserDataStore } from '@/user/store/userDataStore.ts';
import { useContractStore } from '@/contracts/stores/contractStore.ts';

const showCreateModal = ref<boolean>(false);
const { bankAccounts, bankAccountsLoading, bankAccountsError } = storeToRefs(useUserDataStore());

const { fetchContractsAndDepots } = useContractStore();
const { getBankAccounts } = useUserDataStore();

getBankAccounts();
fetchContractsAndDepots();
</script>

<template>
  <PageContentWrapper>
    <div class="flex flex-col md:w-10/12 lg:w-8/12 gap-2 -mx-4 md:mx-auto">
      <h1 class="hidden md:block text-center">Bankverbindungen</h1>

      <div class="md:hidden flex flex-row items-center justify-between mx-4 mt-5">
        <span class="md:hidden font-semibold text-lg">Bankverbindungen</span>
        <AppButton
          class="inline-block float-right"
          type="primary"
          text
          bg
          size="small"
          @click="showCreateModal = true"
        >
          hinzufügen
        </AppButton>
      </div>

      <ElCard>
        <Heading
          level="5"
          text="Bankverbindungen"
          :icon="{
            name: 'money-check-dollar',
            variant: 'regular',
            size: 'lg',
            class: 'text-secondary mr-2',
          }"
          class="hidden md:block border-b border-gray-200 pb-4 mb-6 font-semibold"
        >
          <AppButton
            class="inline-block float-right -mt-1"
            type="primary"
            text
            bg
            size="small"
            @click="showCreateModal = true"
          >
            Bankverbindung hinzufügen
          </AppButton>
        </Heading>

        <BankAccountsSkeleton v-if="bankAccountsLoading" />
        <ElAlert
          v-else-if="bankAccountsError"
          class="my-10"
          type="error"
          title="Es ist leider ein Fehler aufgetreten."
          show-icon
        >
          {{ errorMessage }}
        </ElAlert>
        <div
          v-else-if="bankAccounts?.length > 0"
          class="space-y-5 pt-2 pb-1"
        >
          <BankAccountCard
            v-for="(account, idx) in bankAccounts"
            :key="idx"
            :account="account"
          />
        </div>
        <div
          v-else
          class="flex flex-row p-4 my-4 border bg-gray-50 rounded-lg"
        >
          <span class="text-center w-full">Keine Bankverbindungen vorhanden.</span>
        </div>
      </ElCard>
    </div>

    <CreateBankAccountModal v-model:show="showCreateModal" />
  </PageContentWrapper>
</template>
